// Sabit usta unvan listesi — serbest metin yasak, yalnızca bu listeden seçilir.
export const USTA_TITLES = [
  "Alçıpan & Alçıpan Bölme Duvar Ustası",
  "Asma Tavan Ustası (Taşyünü, Metal, Modüler)",
  "Gergi Tavan Ustası",
  "Ses & Isı İzolasyon / Yalıtım Ustası",
  "Su Yalıtımı & Membran Ustası",
  "Boya & Badana Ustası",
  "Alçı Sıva & Saten Alçı Ustası",
  "Kaba Sıva & Kara Sıva Ustası",
  "Kartonpiyer & Stropiyer Ustası",
  "Dış Cephe & Mantolama Ustası",
  "Duvar Kağıdı Ustası",
  "İtalyan Boya & Efekt Boya Ustası",
  "Epoksi Zemin Kaplama Ustası",
  "Mikrobeton Ustası",
  "Fayans, Seramik & Granit Ustası",
  "Parke, Laminat & Lamine Zemin Ustası",
  "Şap & Tesviye Ustası",
  "Duvar Örme Ustası (Tuğla, Gazbeton/Ytong, Bims)",
  "Doğal Taş & Mermer Kaplama Ustası",
  "Çatı Yapım, Onarım & Oluk Ustası",
  "Kalıp & Demir Ustası (Kaba Yapı)",
  "Kutu Profil, Çelik Karkas & Konstrüksiyon Ustası",
  "Demir Doğrama & Ferforje Ustası",
  "Gazaltı & Elektrot Kaynak Ustası",
  "Çelik Kapı & Yangın Kapısı Montaj Ustası",
  "Otomatik Kepenk, Panjur & Fotoselli Kapı Ustası",
  "Yangın Tesisatı & Sprinkler Ustası",
  "Güvenlik Kamerası, Alarm & Diyafon Sistemleri Ustası",
  "Mutfak Dolabı & Tezgah İmalat/Montaj Ustası",
  "Banyo Dolabı & Tezgah Ustası",
  "Marangoz & Özel Ahşap İmalat Ustası",
  "Mobilya Montaj & Tamir Ustası",
  "Ahşap Kapı / Amerikan Panel Kapı Montaj Ustası",
  "Cam Balkon & Kış Bahçesi Ustası",
  "PVC (Pimapen) & Alüminyum Doğrama Ustası",
  "Duşakabin İmalat & Montaj Ustası",
  "Sıhhi Tesisat (Temiz & Pis Su) Ustası",
  "Su Kaçağı Tespiti & Tıkalı Gider Açma Ustası",
  "Doğalgaz, Kombi & Kalorifer Tesisat Ustası",
  "Kombi Bakım & Tamir Ustası",
  "Radyatör & Petek Temizleme Ustası",
  "Güneş Enerjisi & Boyler Tesisatı Ustası",
  "Elektrik Tesisat & Arıza Ustası",
  "Led Aydınlatma & Spot/Armatür Ustası",
  "Pano Montaj & Kompanzasyon Ustası",
  "Klima Montaj, Bakım & Gaz Dolum Ustası",
  "Havalandırma, Kanal & Baca Sistemleri Ustası",
  "Kırım, Yıkım & Moloz Atım Ekibi",
  "Bahçe Bakım, Çim Biçme & Peyzaj Ustası",
  "Otomatik Bahçe Sulama Ustası",
  "Havuz Yapım, İzolasyon & Bakım Ustası",
  "Evden Eve Nakliyat & Eşya Taşıma",
  "Genel Tadilat & Anahtar Teslim Uygulama Ustası",
  "Çilingir & Kilit Değişimi Ustası",
  "İnşaat Sonrası & Detaylı Ev Temizliği",
];
